import React from 'react'

const Navbar = () => {

  return (
    <div className='navbar'>
      <span className='logo'>VCHAT</span>
    </div>
  )
}

export default Navbar